import history from './history';
import queryString from 'query-string'

export function getDigitsOnly(str) {
  let digits = (str ? str.match(/\d/g) : '');
  digits = (digits ? digits.join('') : '');
  return (digits ? digits.substring(0, 11) : '');
};

export function formatNewsPreviewDate(dateStr) {
  if (!dateStr) return '';

  try {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const day = date.getDay();
    const month = date.toLocaleString('ru-ru', { month: 'long' });
    return `${capitalizeFirstLetter(month)} ${day}, ${year}`;
  } catch (e) {
    return '';
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isPicture(filename) {
  const ext = getFileExtension(filename);
  const extensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg'];
  if (extensions.includes(ext)) {
    return true;
  }
}

export function isVideo(filename) {
  const ext = getFileExtension(filename);
  const extensions = ['mp4', 'ogg'];
  if (extensions.includes(ext)) {
    return true;
  }
}

export function getFileExtension(filename) {
  if (!filename) return '';
  return filename
    .split('.')
    .pop()
    .toLowerCase();
}

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
}

export function removeDuplicates(myArr, prop) {
  return myArr.filter(
    (obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos,
  );
}

export function getRandomColor() {
  const colorArray = [
    '#2D9A43',
    '#005CAB',
    '#574AEF',
    '#F58025',
    '#0072FF',
    '#73C984',
    '#FB4978',
    '#6C2196',
  ];
  const randomColor = colorArray[Math.floor(Math.random() * colorArray.length)];
  return randomColor;
}

export function getRandomColors(n) {
  const randomColors = [];
  while (randomColors.length < n) {
    const color = getRandomColor();
    if (!randomColors.includes(color)) {
      randomColors.push(color);
    }
  }
  return randomColors;
}

export function getCleanText(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';
  return text;
}

export function selectedTextInPost(node, textClass) {
  let sel;
  if (document.getSelection) sel = document.getSelection();
  else sel = document.selection.createRange();
  let selText = '';
  if (sel.rangeCount > 0) {
    const range = sel.getRangeAt(0);
    let clonedSelection = range.cloneContents();
    clonedSelection = range.cloneContents();
    const startNode = sel.getRangeAt(0).startContainer.parentNode;
    if (isChild(startNode, node) || isSibling(startNode, node)) {
      const div = document.createElement('div');
      div.appendChild(clonedSelection);
      selText = div.innerHTML;
    }
  }
  let targetText = '';
  const targetTextRegex = new RegExp(`<div[^>]*${textClass}[^>]*>(.*?)</div>`, 'gi');
  const targetTextMatch = targetTextRegex.exec(selText);
  targetText = targetTextMatch && targetTextMatch[1] ? targetTextMatch[1] : selText;

  const result = targetText
    .replace(new RegExp('<blockquote[^>]*>(.*)</blockquote>|<div[^>]*>(.*)</div>', 'gi'), '')
    .replace(new RegExp('style="[^"]*"', 'gi'), '');

  return result;
}

function isChild(child, parent) {
  if (child === parent) return true;
  let current = child;
  while (current) {
    if (current === parent) return true;
    current = current.parentNode;
  }
  return false;
}

function isSibling(child1, child2) {
  if (child1 === child2) return true;
  const parent = child1.parentNode;
  if (isChild(child2, parent)) return true;
  return false;
}

export function parseText(text) {
  const regex = /<blockquote[^>]*>(.*)<\/blockquote>/gi;
  const exptyDivs = /<div[^>]*>(.*)<\/div>/gi;
  const match = regex.exec(text);
  const blockquote = match && match[1] ? match[1] : '';
  const reply = text.replace(regex, '').replace(exptyDivs, '');

  return { blockquote, reply };
}

export function setUrlParameters(elements, callback = null) {

  const newQuery = queryString.parse(window.location.search);
  for (var key in elements) {
    newQuery[key] = elements[key];
  }

  let search = '';
  for (var key in newQuery) {
    if (!newQuery[key]) {
      continue;
    }

    if (search.indexOf('?') < 0) {
      search += '?' + key + '=' + newQuery[key];
    } else {
      search += '&' + key + '=' + newQuery[key];
    }
  }
  
  if (window.location.search !== search) {
    history.push({
      pathname: window.location.pathname,
      search: search
    });
  }

  if (callback) {
    callback();
  }
}

// getNoun(4, 'год', 'года', 'лет')
export function getNoun(number, one, two, five) {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
}
